
import { defineComponent } from 'vue';
import BookmarkItem from '@/components/BookmarkItem.vue';

export default defineComponent({
  name: 'bookmark-list',
  components: {
    BookmarkItem,
  },
  props: {
    bookmarks: {
      type: Array,
      required: true,
    },
  },
});
